module.exports = __webpack_public_path__ + "media/images/gimmicks/gimmick-diamond-2b83e04036fd5a73f73a73dfe9e10a72.svg";